import axios from "axios"

import store from "@/store"
import { refreshToken } from "@/store/modules/auth/providers/api"

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://imsapi.appliedmfg.com"
      : "http://localhost:3000"
})

api.interceptors.response.use(undefined, function(err) {
  let originalRequest = err.response.config
  if (err.response.status === 401 && !originalRequest._retry) {
    if (store.getters.getRefreshToken) {
      // only retry if we have a token
      originalRequest._retry = true
      return refreshToken()
        .then(res => {
          const { accessToken } = res.data
          store.commit("setAccessToken", accessToken)
          setAuthHeader(accessToken)
          store.dispatch("updateLocalAccessToken", accessToken)
          originalRequest.headers["Authorization"] = accessToken

          return api(originalRequest)
        })
        .catch(error => {
          console.warn("Error in auth interceptor", error)
          store.dispatch("clearAuth")
        })
    }
  }
  throw err // pass error along so we can handle it later
})

export const setAuthHeader = token => {
  api.defaults.headers.common["Authorization"] = token
}

export const clearAuthHeader = () => {
  delete api.defaults.headers.common["Authorization"]
}

export default api
